var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "icon-edit",
    "data-name": "Layer 1",
    viewBox: "0 0 200 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "green",
    d: "M64.41,137.76H62.66c-5.84.05-8.51-2.16-8-7.88.52-6.3.37-12.57.5-18.86a4.64,4.64,0,0,1,1.65-3.31q20.7-20.65,41.36-41.35c1.56-1.57,2.69-1.71,4.32-.06Q114.13,78.12,126,89.75c1.47,1.45,1.62,2.55.09,4.07q-21,20.9-41.81,41.89a4,4,0,0,1-3.08,1.35A158.81,158.81,0,0,0,64.41,137.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "green",
    d: "M145.47,70c-.08,3.8-5.42,11.67-8.71,12.9-1.11.42-1.77-.19-2.44-.85-8.23-8.23-16.43-16.49-24.69-24.69-1.2-1.19-1.19-2.1.07-3.14a78.82,78.82,0,0,1,6.39-5.36c4.69-3.15,10.21-2.56,14.33,1.4Q136.33,56,142,61.91A11.62,11.62,0,0,1,145.47,70Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f0f11757d01b04e7adc827c498f866f0.svg";
export { ForwardRef as ReactComponent };